import styled from "styled-components";

const bp = { md: "980px" };

const c = {
  black: "#1e1e1e",
  black2: "#141414",
  white: "#ffffff",
  whiteSoft: "rgba(255,255,255,0.78)",
  gold: "#c9a227",
  goldSoft: "rgba(201,162,39,0.35)",
  pink: "#f1b6cf",
  pinkSoft: "rgba(241,182,207,0.35)",

  text: "rgba(24, 14, 14, 0.88)",
  textSoft: "rgba(24, 14, 14, 0.65)",
};

export const Section = styled.section`
  background: transparent;
  padding: 45px 0;

  @media (max-width: ${bp.md}) {
    padding: 20px 0;
  }
`;

export const Inner = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;

  @media (max-width: ${bp.md}) {
    padding: 0 16px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  margin-bottom: 58px;

  @media (max-width: ${bp.md}) {
    grid-template-columns: 1fr;
    gap: 18px;

    justify-items: center;
  }
`;

export const Card = styled.article`
  position: relative;
  background: ${c.black};
  border-radius: 22px;
  padding: 30px;
  text-align: left;
  isolation: isolate;

  aspect-ratio: 1 / 1.05;
  display: flex;
  flex-direction: column;
  gap: 18px;

  border: 1px solid rgba(201, 162, 39, 0.75);

  &::before {
    content: "";
    position: absolute;
    inset: 10px;
    border-radius: 16px;
    border: 1px solid rgba(241, 182, 207, 0.22);
    pointer-events: none;
    z-index: 0;
  }

  box-shadow:
    0 10px 24px rgba(0, 0, 0, 0.22),
    0 0 0 1px rgba(255, 255, 255, 0.04) inset;

  transition:
    transform 240ms ease,
    box-shadow 240ms ease,
    border-color 240ms ease;

  &:hover {
    transform: translateY(-3px);
    border-color: rgba(201, 162, 39, 0.92);
    box-shadow:
      0 14px 34px rgba(0, 0, 0, 0.28),
      0 0 0 1px rgba(255, 255, 255, 0.05) inset;
  }

  @media (max-width: ${bp.md}) {
    aspect-ratio: auto;

    width: 100%;
    max-width: 520px;
  }
`;

export const CardTitle = styled.h3`
  position: relative;
  z-index: 1;
  margin: 0 0 18px;

  font-family: "Ephesis", cursive;
  font-size: 30px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: ${c.white};

  padding-bottom: 14px;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 4px;
    width: 72%;
    height: 2px;
    background: rgba(201, 162, 39, 0.9);
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 58%;
    height: 1px;
    background: rgba(241, 182, 207, 0.55);
  }
`;

export const ImgWrap = styled.div`
  position: relative;
  z-index: 1;

  width: 100%;
  flex: 1;
  min-height: 220px;
  border-radius: 16px;
  overflow: hidden;

  background: ${c.black2};

  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow:
    0 0 0 1px rgba(201, 162, 39, 0.25),
    0 0 0 4px rgba(0, 0, 0, 0.18) inset;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    border-radius: 16px;
    box-shadow: 0 0 0 1px rgba(241, 182, 207, 0.18) inset;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`;

export const DecorativeLine = styled.div`
  position: relative;
  width: min(560px, 92%);
  height: 5px;
  margin: 0 auto 44px;
  background: rgba(201, 162, 39, 0.92);
  border-radius: 999px;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    top: -9px;
    transform: translateX(-50%) rotate(45deg);
    width: 16px;
    height: 17px;

    background: linear-gradient(145deg, #f3e2a4, #c9a227);
    box-shadow: 0 6px 16px rgba(201, 162, 39, 0.25);
  }
`;

export const Header = styled.div`
  max-width: 900px;
  margin: 0 auto 50px;
  text-align: center;
  padding: 0 20px;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 44px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: ${c.text};

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const Subtitle = styled.div`
  margin-top: 12px;
  font-family: "Ephesis", cursive;
  font-size: 28px;
  color: ${c.textSoft};

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const BottomText = styled.p`
  max-width: 860px;
  margin: 0 auto;
  text-align: center;

  font-family: "Cormorant Garamond", serif;
  font-size: 20px;
  line-height: 1.9;

  @media (max-width: 768px) {
    line-height: 1.4;
  }

  letter-spacing: 0.01em;

  color: rgba(24, 14, 14, 0.78);
`;
